import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

const ImporteDebeFormGroup = ({
  vTipoCambio,
  vMoneda,
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue,
  handleChange,
  updateStore,
  rowIndex
}) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      let nuevoValor = e.target.value
      if (!nuevoValor) {
        setFieldValue('dh', '')
      } else {
        setFieldValue('dh', DhContabilidadConstant.DEBE)
      }


      setFieldValue('importeHaber', '')
      setTimeout(() => {
        updateStore()
      }, 150)
    },
    [handleChange, setFieldValue, updateStore]
  )

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`input-det-importeHaber-${rowIndex}`, e)
    },
    [rowIndex]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='importeDebe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id={`input-det-importeDebe-${rowIndex}`}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteDebeFormGroup)
